import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Toaster as SonnerToaster } from "./components/ui/sonner";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import RoomsPage from "./pages/RoomsPage";
import RoomDetailPage from "./pages/RoomDetailPage";
import BookingPage from "./pages/BookingPage";
import BookingConfirmationPage from "./pages/BookingConfirmationPage";
import PaymentStatusPage from "./pages/PaymentStatusPage";
import GalleryPage from "./pages/GalleryPage";
import ReviewsPage from "./pages/ReviewsPage";
import FacilitiesPage from "./pages/FacilitiesPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

// Admin Pages
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminRoomsPage from "./pages/admin/AdminRoomsPage";
import AdminBookingsPage from "./pages/admin/AdminBookingsPage";
import AdminReviewsPage from "./pages/admin/AdminReviewsPage";
import AdminRoomTypesPage from "./pages/admin/AdminRoomTypesPage";
import AdminBillingPage from "./pages/admin/AdminBillingPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminGalleryPage from "./pages/admin/AdminGalleryPage";
import AdminEmailSettingsPage from "./pages/admin/AdminEmailSettingsPage";
import AdminWebhookSettingsPage from "./pages/admin/AdminWebhookSettingsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/rooms" element={<RoomsPage />} />
            <Route path="/rooms/:roomId" element={<RoomDetailPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking-confirmation" element={<BookingConfirmationPage />} />
            <Route path="/payment-status" element={<PaymentStatusPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/facilities" element={<FacilitiesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/rooms" element={<AdminRoomsPage />} />
            <Route path="/admin/bookings" element={<AdminBookingsPage />} />
            <Route path="/admin/reviews" element={<AdminReviewsPage />} />
            <Route path="/admin/room-types" element={<AdminRoomTypesPage />} />
            <Route path="/admin/billing" element={<AdminBillingPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/gallery" element={<AdminGalleryPage />} />
            <Route path="/admin/email-settings" element={<AdminEmailSettingsPage />} />
            <Route path="/admin/webhooks" element={<AdminWebhookSettingsPage />} />
          </Routes>
          <Footer />
          <Toaster />
          <SonnerToaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
